import { create } from 'zustand';
import type { Role } from '@/shared/guards/roles';

/**
 * "Visualizar como" — sys-admin sobrepõe os próprios papéis por UM papel, para
 * testar visualmente as regras de rota/menu que os devs implementaram (gating de
 * UI). É só client-side: o backend continua vendo o admin real (acesso total),
 * então isto NÃO testa autorização de backend — só o gating do front.
 *
 * Em memória de propósito: sobrevive à navegação (SPA), reseta no reload — não
 * deixa o admin "preso" num papel sem perceber. O banner no header torna o
 * estado sempre explícito.
 */
interface ViewAsState {
  viewAsRole: Role | null;
  setViewAsRole: (role: Role | null) => void;
  clearViewAs: () => void;
}

export const useViewAsStore = create<ViewAsState>((set) => ({
  viewAsRole: null,
  setViewAsRole: (viewAsRole) => set({ viewAsRole }),
  clearViewAs: () => set({ viewAsRole: null }),
}));
